import { parseAsArrayOf, parseAsString, ParserBuilder } from 'nuqs/server';

import type { ToggleGroupFilter } from './filters-panel';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getFilterParsers(filters: ToggleGroupFilter[]): Record<string, ParserBuilder<any>> {
  return Object.fromEntries(
    filters.map((filter) => [filter.paramName, parseAsArrayOf(parseAsString)]),
  );
}
